export default {
    data: () => ({
        translations: {
            title: {
                el: "Προβολή Τοποθεσίας",
                en: "Pin Display",
                it: "Visualizza posizione Visualizza posizione"
            },
            info: {
                el: "Εδώ μπορείτε να αλλάξετε την εμφάνιση της τοποθεσίας  στο χάρτη:",
                en: "Here you can change the display of the pin on the map:",
                it: "Qui puoi cambiare l'aspetto della posizione sulla mappa"
            },
            uploadText: {
                el: "Πατήστε στο κουμπί για να επιλέξετε εικόνα:",
                en: "Press the following button to choose image:",
                it: "Tocca il pulsante per selezionare un'immagine:"
            },
            validationError: {
                el: "Για να συνεχίσετε πρέπει να ανεβάσετε μια νέα εικόνα",
                en: "To continue you must upload a new image",
                it: "Per continuare è necessario caricare una nuova immagine"
            }
        }
    })
};
